/**
 * Shared constants for DocRanker and document filter components.
 */

/** Cancer type options for relevance ranking filter */
export const CANCER_TYPE_OPTIONS = [
    { label: 'Prostate', value: 'prostate' },
    { label: 'Bladder', value: 'bladder' },
    { label: 'Lung', value: 'lung' },
    { label: 'Breast', value: 'breast' },
    { label: 'Colorectal', value: 'colorectal' },
    { label: 'Pancreatic', value: 'pancreatic' },
] as const;

/** Score marks for the relevance score slider */
export const DOC_RANKER_SCORE_MARKS = {
    0: '0',
    25: '25',
    50: '50',
    75: '75',
    100: '100',
};

/** Default minimum relevance score threshold */
export const DEFAULT_MIN_SCORE = 50;
